import React, { Component } from "react";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer } from "recharts";
import months from "../../../../_constants/months";
import moment from "moment";
import "./widget.css";

export default class SafetyCommentsRaised extends Component {
  getChartData = () => {
    const { data } = this.props;

    // TODO: modify component to handle multiple kw's
    const firstKw = data && Object.keys(data)[0];

    let chartData = [];
    const firstMonth = moment().subtract(6, "M");
    const secondMonth = firstMonth.clone().add(1, "M");
    const thirdMonth = secondMonth.clone().add(1, "M");
    const fourthMonth = thirdMonth.clone().add(1, "M");
    const fifthMonth = fourthMonth.clone().add(1, "M");
    const sixthMonth = fifthMonth.clone().add(1, "M");

    // Initialize data container
    for (let m = 0; m < 6; m++) {
      chartData.push({
        month: months[firstMonth.clone().add(m, "M").month()],
        count: 0,
      });
    }
    if (data && data[firstKw]) {
      data[firstKw].forEach((d) => {
        const date = moment(d);
        if (date >= firstMonth.startOf("month") && date <= firstMonth.endOf("month"))
          chartData[0].count++;
        if (date >= secondMonth.startOf("month") && date <= secondMonth.endOf("month"))
          chartData[1].count++;
        if (date >= thirdMonth.startOf("month") && date <= thirdMonth.endOf("month"))
          chartData[2].count++;
        if (date >= fourthMonth.startOf("month") && date <= fourthMonth.endOf("month"))
          chartData[3].count++;
        if (date >= fifthMonth.startOf("month") && date <= fifthMonth.endOf("month"))
          chartData[4].count++;
        if (date >= sixthMonth.startOf("month") && date <= sixthMonth.endOf("month"))
          chartData[5].count++;
      });
    }
    return chartData;
  };

  render() {
    return (
      <div className="widget-container">
        <ResponsiveContainer width="100%" height={110}>
          <LineChart
            data={this.getChartData()}
            margin={{ top: 2, right: 5, left: 0, bottom: 0 }}
          >
            <XAxis dataKey="month" />
            <YAxis padding={{ bottom: 0 }} />
            <Line type="monotone" dataKey="count" stroke="#8884d8" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
